import { template } from "@ember/template-compiler";
import './hero.css';
import type { TOC } from '@ember/component/template-only';
export const Hero: TOC<{
    /**
   * The wrapper element of the whole layout.
   */ Element: HTMLDivElement;
    Blocks: {
        default: [];
    };
}> = template(`
  <div class="ember-primitives__hero__wrapper" ...attributes>
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2VtYmVyLXByaW1pdGl2ZXMvZW1iZXItcHJpbWl0aXZlcy9lbWJlci1wcmltaXRpdmVzL3NyYy9jb21wb25lbnRzL2xheW91dC9oZXJvLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgJy4vaGVyby5jc3MnO1xuXG5pbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5cbmV4cG9ydCBjb25zdCBIZXJvOiBUT0M8e1xuICAvKipcbiAgICogVGhlIHdyYXBwZXIgZWxlbWVudCBvZiB0aGUgd2hvbGUgbGF5b3V0LlxuICAgKi9cbiAgRWxlbWVudDogSFRNTERpdkVsZW1lbnQ7XG4gIEJsb2Nrczoge1xuICAgIGRlZmF1bHQ6IFtdO1xuICB9O1xufT4gPSA8dGVtcGxhdGU-XG4gIDxkaXYgY2xhc3M9XCJlbWJlci1wcmltaXRpdmVzX19oZXJvX193cmFwcGVyXCIgLi4uYXR0cmlidXRlcz5cbiAgICB7e3lpZWxkfX1cbiAgPC9kaXY-XG48L3RlbXBsYXRlPjtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxhQUFhO0FBRXBCLGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUUxRCxPQUFPLE1BQU0sTUFBTTtJQUNqQjs7R0FFQyxHQUNELFNBQVM7SUFDVDtRQUNFOztLQUVDLFNBQVUsQ0FBQTs7OztBQUlmLENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQSxHQUFFIn0